import { Component, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { PageTitleService } from '@marketing/page-title/page-title.service';
import { Labels, LabelCollection } from '@utils/labels';
import { Component as BrComponent } from '@bloomreach/spa-sdk/';
import { Page, Reference } from '@bloomreach/spa-sdk';

@Component({
  selector: 'ft-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss'],
})
export class ProfileListComponent implements OnInit {
  @Input() component!: BrComponent;
  @Input() page!: Page;
  profiles: any;

  constructor(
    private titleService: Title,
    private pageTitleService: PageTitleService,
    private meta: Meta
  ) {}

  /**
   * On init hook
   */
  ngOnInit() {
    const profileRefs = this.component.getModels<DocumentData>()?.documents;
    const profileDocs: any = profileRefs.map((ref) =>
      this.page.getContent(ref)
    );
    if (profileDocs) {
      this.profiles = profileDocs.map((profile) => profile.model);
    }
  }
}
